import React, {memo} from "react";

/** Code-brackets style icon for “copy evidence to clipboard” actions */
export const IconCopyEvidence = memo(({color, addClass}) => {
  const fill = color || "#000";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
    >
      <path
        d="M4.99976 15C4.87176 15 4.74376 14.951 4.64576 14.854L0.645762 10.854C0.450762 10.659 0.450762 10.342 0.645762 10.147L4.64576 6.14698C4.84076 5.95198 5.15776 5.95198 5.35276 6.14698C5.54776 6.34198 5.54776 6.65898 5.35276 6.85398L1.70676 10.5L5.35276 14.146C5.54776 14.341 5.54776 14.658 5.35276 14.853C5.25476 14.951 5.12676 14.999 4.99876 14.999L4.99976 15Z"
        fill={fill}
      />
      <path
        d="M14.9998 15C14.8718 15 14.7438 14.951 14.6458 14.854C14.4508 14.659 14.4508 14.342 14.6458 14.147L18.2918 10.501L14.6458 6.85496C14.4508 6.65996 14.4508 6.34296 14.6458 6.14796C14.8408 5.95296 15.1578 5.95296 15.3528 6.14796L19.3528 10.148C19.5478 10.343 19.5478 10.66 19.3528 10.855L15.3528 14.855C15.2548 14.953 15.1268 15.001 14.9988 15.001L14.9998 15Z"
        fill={fill}
      />
      <path
        d="M7.49987 15.0001C7.40887 15.0001 7.31787 14.9751 7.23487 14.9241C7.00087 14.7781 6.92987 14.4691 7.07587 14.2351L12.0759 6.23511C12.2219 6.00111 12.5309 5.93011 12.7649 6.07611C12.9989 6.22211 13.0699 6.53111 12.9239 6.76511L7.92387 14.7651C7.82887 14.9171 7.66587 15.0001 7.49987 15.0001Z"
        fill={fill}
      />
    </svg>
  );
});
